<script lang="ts">
  import { type PlayerInterface } from '@foundation-player/loader';
  import { getContext } from 'svelte';
  import PlayPause from '../../shared/components/PlayPause.svelte';
  import ReplayButton from '../../shared/components/ReplayButton.svelte';
  import type { FocusLayer } from '../../shared/focus-manager/focus-types';
  import type { PlayerStateContext } from '../../shared/types/player-state';
  import type { UIStateContext } from '../types/internal/ui-state';
  import SeekButton from './SeekButton.svelte';
  import StartButton from './StartButton.svelte';

  export let player: PlayerInterface | undefined = undefined;
  export let focusLayer: FocusLayer;

  const { linearAdPlaying, liveMedium, sessionState } = getContext<PlayerStateContext>('playerState');
  const { nextMediumPreviewCurrentlyShown, waitingForFirstInteraction } = getContext<UIStateContext>('uiState');

  $: showSeekButtons = !$waitingForFirstInteraction && !$liveMedium && !$linearAdPlaying && $sessionState !== 'ended';
  $: showReplayButton = !$liveMedium && $sessionState === 'ended' && !$nextMediumPreviewCurrentlyShown;
</script>

<div class="prime-controls">
  {#if showSeekButtons}
    <div class="left">
      {#if player}
        <SeekButton {player} size="l" seekOffsetInSeconds={-10} {focusLayer} focusName="seekBackwardPrime" />
      {/if}
    </div>
  {/if}

  <div class="center">
    {#if $waitingForFirstInteraction}
      <StartButton size="xl" focusLayer="start" focusName="startPrime" />
    {:else if player}
      {#if showReplayButton}
        <ReplayButton {player} size="xl" focusLayer="replay" focusName="replayPrime" />
      {:else}
        <PlayPause {player} size="xl" {focusLayer} focusName="playPausePrime" />
      {/if}
    {/if}
  </div>

  {#if showSeekButtons}
    <div class="right">
      {#if player}
        <SeekButton {player} size="l" seekOffsetInSeconds={10} {focusLayer} focusName="seekForwardPrime" />
      {/if}
    </div>
  {/if}
</div>

<style module>
  .prime-controls {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .center {
    margin: 0 20px;
    /* 20px @400px, 50px @1000px */
    margin: 0 clamp(20px, 5cqw, 50px);
  }

  @media (prefers-contrast: more) {
    :global([data-mode='video']) :is(.left, .center, .right) {
      background: var(--controls-contrast-background);
    }
  }

  @media (prefers-contrast: more) and (prefers-reduced-transparency: reduce) {
    :global([data-mode='video']) :is(.left, .center, .right) {
      background: var(--controls-no-transparency-background);
    }
  }
</style>
